import { Link } from 'react-router-dom'
import ContentShell from '../../components/blog/ContentShell'
import Seo from '../../components/blog/Seo'
import Breadcrumbs from '../../components/blog/Breadcrumbs'
import { getAllTools } from '../../lib/blog/tools'
import { breadcrumbJsonLd } from '../../lib/seo'

export default function ToolsIndex() {
  const tools = getAllTools()
  return (
    <ContentShell>
      <Seo
        title="Free Tools | BankStatementReader"
        description="Free tools for working with bank statements: convert PDF to Excel/CSV, reconcile, track expenses, and more."
        canonicalPath="/tools"
        jsonLd={[breadcrumbJsonLd([{ name: 'Home', path: '/' }, { name: 'Tools', path: '/tools' }])]}
      />
      <div className="mx-auto max-w-5xl pt-6">
        <Breadcrumbs crumbs={[{ name: 'Home', path: '/' }, { name: 'Tools', path: '/tools' }]} />
        <h1 className="text-[clamp(2rem,3vw+1rem,2.8rem)] font-bold tracking-tight text-ink m-0">Free Tools</h1>
        <p className="text-ink-soft mt-3 mb-8">Free, no-signup tools for bank statement and bookkeeping workflows.</p>
        <div className="grid gap-6 md:grid-cols-3">
          {tools.map((t) => (
            <article key={t.slug} className="rounded-2xl border border-black/5 bg-surface p-6 hover:-translate-y-0.5 hover:shadow-soft transition">
              <Link to={`/tools/${t.slug}`}>
                <h2 className="text-lg font-bold text-ink m-0">{t.title}</h2>
                <p className="text-[0.92rem] text-ink-soft mt-2 mb-0">{t.description}</p>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </ContentShell>
  )
}
